/* eslint-disable no-console */

import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'Register: READY - App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
      );
    },
    registered(registration) {
      console.log('Register - Service worker has been registered.');
      setInterval(() => {
        console.log('Register: registered update');
        registration.update();
      }, 1000 * 10);
    },
    cached() {
      console.log('Register: Content has been cached for offline use.');
    },
    updatefound() {
      console.log('Register: New content is downloading.');
    },
    updated(registration) {
      console.log('Register: New content is available; please refresh.');
      document.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
    },
    offline() {
      console.log('Register: No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Register: Error during service worker registration:', error);
    }
  });
}
